import crud from "./CRUD"

const PATH = "/numberPlateTypes"

export const getNumberPlateTypes = async () => crud.get(PATH)
